var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialNetworkIconWebsite = function SvgSocialNetworkIconWebsite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    viewBox: "0 0 16 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0H.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h5.7l-.926 2.314a.5.5 0 0 0 .465.686h4.52a.5.5 0 0 0 .464-.687L9.788 11H15.5a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5zM14 9.035H2v-7h12v7z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialNetworkIconWebsite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "c7a14069259c258ab153a63953e627a9.svg";